var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonGroup, IconButton } from "@mui/joy";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useEffect, useState } from "react";
import { usePopup } from "@/hooks/layout";
import { useLogger } from "@/utils/loggerService";
import { setModuleList } from "@/store/layoutSlice";
import { useAppDispatch } from "@/hooks/store";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/pro-solid-svg-icons";
import WidgetEditor from "./widgetEditor";
import { useTranslation } from "react-i18next";
import { ETCRM_URL } from "@/utils/const";
import { getDisplayWidgetSizes, isWidgetAvailableArea, } from "@/components/forms/components/utils";
import { smallSlot } from "@/utils/types/layout";
export default function WidgetSelector(_a) {
    var _this = this;
    var _b, _c;
    var widget = _a.widget;
    var closePopup = usePopup().closePopup;
    var logger = useLogger().logger;
    var dispatch = useAppDispatch();
    var _d = useState(false), widthExceeded = _d[0], setWidthExceeded = _d[1];
    var _e = useParams(), packagesName = _e.packagesName, moduleName = _e.moduleName, type = _e.type, menu = _e.menu, dropdownName = _e.dropdownName, actionWidget = _e.actionWidget;
    var entries = widgetsDictionary.entries().filter(function (wd) {
        var isSelectable = wd[1].selectable === undefined || wd[1].selectable === true;
        var isNotVerticalMenu = !(widget.payload.direction === "HORIZONTAL" &&
            wd[1].name === "Simple menu");
        return isSelectable && isNotVerticalMenu;
    });
    var _f = useState(), selection = _f[0], setSelection = _f[1];
    // Selected widget
    var _g = useState(), selectedWidget = _g[0], setSelectedWidget = _g[1];
    var _h = useState(entries), widgetList = _h[0], setWidgetList = _h[1];
    var sizeOptions = getDisplayWidgetSizes(selection === null || selection === void 0 ? void 0 : selection[0]);
    useEffect(function () {
        var _a;
        if (selection) {
            var newWidget = {
                id: "",
                type: selection[0],
                payload: __assign({ currentTotalColspan: ((_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.currentTotalColspan) || 1 }, (sizeOptions && { sizeOptions: sizeOptions })),
            };
            setSelectedWidget(newWidget);
            return;
        }
        setSelectedWidget(undefined);
    }, [selection]);
    var widgetDefinition = selection
        ? selection[1]
        : undefined;
    //Gestion du bouton selection pour le widget ayant la propriété
    var _j = useState(false), disabled = _j[0], setDisabled = _j[1];
    function isEmptyOrHasNullValues(payload) {
        if (payload) {
            if (Object.keys(payload).length === 0) {
                return true;
            }
            for (var key in payload) {
                if (payload[key] === null) {
                    return true;
                }
            }
        }
        return false;
    }
    useEffect(function () {
        (widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.validation) &&
            setDisabled(isEmptyOrHasNullValues(selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.payload));
    }, [widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.validation, selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.payload]);
    var uuidv4 = require("uuid").v4;
    var _k = useState(selectedWidget), widgetPayload = _k[0], setWidgetPayload = _k[1];
    var setUpdate = function (value) {
        setWidgetPayload(value);
    };
    var _l = useState(widget), editedWidget = _l[0], setEditedWidget = _l[1];
    var _m = useState(), active = _m[0], setActive = _m[1];
    var t = useTranslation(["common"]).t;
    var handleChange = function (val) { return __awaiter(_this, void 0, void 0, function () {
        var autocompletion;
        return __generator(this, function (_a) {
            autocompletion = entries.filter(function (item) {
                var lowerValue = item[1].name.toLowerCase();
                return (lowerValue.includes(val.target.value) ||
                    item[1].name.includes(val.target.value));
            });
            setWidgetList(autocompletion);
            return [2 /*return*/];
        });
    }); };
    var isButtonDisabled = disabled || widthExceeded;
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "flex flex-col min-w-[1100px] overflow-hidden" }, { children: [_jsxs("div", __assign({ className: "flex flex-rows mb-4" }, { children: [_jsx("h2", __assign({ className: "font-bold font-[16px]" }, { children: t("app.LBL_WIDGET_CONFIG", { ns: "common" }) })), _jsx(ButtonGroup, __assign({ sx: {
                                backgroundColor: "var(--color-brand-neutral-50)",
                                "--icon-color": "red",
                                transition: "all 0.25s",
                                ":hover": {
                                    opacity: 1,
                                },
                            } }, { children: _jsx(IconButton, __assign({ sx: {
                                    width: "40px",
                                    border: "none",
                                    marginTop: "-8px",
                                }, onClick: function () {
                                    var _a;
                                    setEditedWidget(__assign(__assign({}, editedWidget), { meta: __assign(__assign({}, editedWidget.meta), { pinned: !((_a = editedWidget.meta) === null || _a === void 0 ? void 0 : _a.pinned) }) }));
                                } }, { children: _jsx(FontAwesomeIcon, { icon: ((_b = editedWidget === null || editedWidget === void 0 ? void 0 : editedWidget.meta) === null || _b === void 0 ? void 0 : _b.pinned) ? faLock : faLockOpen }) })) }))] })), _jsxs("div", __assign({ className: "grid grid-cols-3 border-2 border-gray-300 rounded-sm max-h-[400px] overflow-y-auto" }, { children: [_jsx("div", __assign({ className: "bg-gray-100" }, { children: _jsxs("div", __assign({ className: "flex flex-col my-5" }, { children: [_jsx("input", { placeholder: String(t("app.LBL_SEARCH_WIDGET", { ns: "common" })), className: "border-2 rounded-md p-2 mx-4", onChange: function (val) { return handleChange(val); } }), _jsx("ul", __assign({ className: "border-t-2 mt-4" }, { children: widgetList.map(function (item, idx) {
                                            var _a, _b, _c, _d;
                                            var availability = isWidgetAvailableArea(item[0]);
                                            var isSmallSlotCurrent = ((_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.slot) &&
                                                smallSlot.includes((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.slot);
                                            var isAllowed = isSmallSlotCurrent
                                                ? availability.canBeInSmallSlot
                                                : availability.canBeInBigSlot;
                                            return (_jsx("li", __assign({ onClick: function (e) {
                                                    setSelection(item);
                                                    e.stopPropagation();
                                                    setActive(idx);
                                                }, className: "cursor-pointer py-2 mx-4 ".concat(active === idx
                                                    ? "bg-blue-100 border-2 border-blue-500 rounded-md pl-2"
                                                    : "pl-2") }, { children: _jsxs("div", __assign({ className: "flex flex-row items-center" }, { children: [((_c = item[1]) === null || _c === void 0 ? void 0 : _c.icon) && (_jsx("img", { src: "".concat(ETCRM_URL).concat((_d = item[1]) === null || _d === void 0 ? void 0 : _d.icon), className: "pr-2" })), _jsx("label", __assign({ className: "".concat(!isAllowed ? "opacity-50 cursor-not-allowed " : "") }, { children: item[1].name }))] })) }), item[0]));
                                        }) }))] })) })), selection && (_jsx(WidgetEditor, { selected: selectedWidget, update: setUpdate, widgetDefinition: widgetDefinition, currentSlot: (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.slot, onValidationChange: function (disabled) { return setWidthExceeded(disabled); } }))] })), _jsxs("div", __assign({ className: "flex mt-8 mb-4 text-center md:text-right md:justify-end ".concat(disabled ? "cursor-not-allowed" : "") }, { children: [_jsx("div", { children: _jsx("button", __assign({ className: "button secondary  block w-full px-4 py-3 text-sm font-semibold md:inline-block md:w-auto md:py-2 md:mt-0 md:order-1", onClick: function () {
                                    if (actionWidget === "addWidget") {
                                        setSelection(null);
                                    }
                                    closePopup(widget.id, undefined, widget.slot);
                                    logger.debug("[WIDGET SELECTOR] - Cancel", widgetPayload);
                                } }, { children: t("app.LBL_CANCEL", { ns: "common" }) })) }), _jsx("div", { children: _jsx("button", __assign({ 
                                //className="block w-full px-4 py-3 text-sm font-semibold text-red-700 bg-red-200 rounded-lg md:inline-block md:w-auto md:py-2 md:ml-2 md:order-2 hover:text-red-200 hover:bg-red-700"
                                className: "block button danger w-full px-4 py-3 text-sm font-semibold ".concat(isButtonDisabled ? "text-gray-400 bg-gray-200  disabled " : "", "  md:inline-block md:w-auto md:py-2 md:ml-2"), onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var updatedWidget;
                                    return __generator(this, function (_a) {
                                        if (!selection) {
                                            return [2 /*return*/];
                                        }
                                        //if actionWidget exists
                                        if (actionWidget === "addWidget") {
                                            if (!(widgetPayload === null || widgetPayload === void 0 ? void 0 : widgetPayload.id)) {
                                                updatedWidget = __assign(__assign({}, widgetPayload), { id: uuidv4() });
                                                setSelectedWidget(updatedWidget);
                                                dispatch(setModuleList({
                                                    widget: updatedWidget,
                                                    module: moduleName,
                                                }));
                                            }
                                            else {
                                                dispatch(setModuleList({
                                                    widget: widgetPayload,
                                                    module: moduleName,
                                                }));
                                            }
                                        }
                                        closePopup(widget.id, widgetPayload, widget.slot);
                                        logger.debug("[WIDGET SELECTOR] - Select", widgetPayload);
                                        return [2 /*return*/];
                                    });
                                }); } }, { children: t("app.LBL_WIDGET_SELECT") })) })] }))] })) }));
}
widgetsDictionary.register("widget/selector", {
    name: "Selecteur de widget",
    display: WidgetSelector,
    selectable: false,
    editable: false,
});
